import { useLocation } from 'react-router-dom';
import { useRestaurantContext } from '../../../contexts/RestaurantContext';
import PageHeader from '../../../components/PageHeader';
import DesignColorsTab from './components/DesignColorsTab';
import DesignFontsTab from './components/DesignFontsTab';
import { DesignTab } from './designPageTypes';

const getDesignTab = (pathname: string): DesignTab => (pathname.includes('/fonts') ? 'fonts' : 'colors');

const DESIGN_TAB_TITLES: Record<DesignTab, string> = {
  colors: 'COLORS',
  fonts: 'FONTS'
};

const DesignPage = () => {
  const { pathname } = useLocation();
  const tab = getDesignTab(pathname);
  const { currentRestaurant } = useRestaurantContext();
  const hasRestaurant = !!currentRestaurant?.restaurantID;

  return (
    <div className="design-page">
      <PageHeader title={DESIGN_TAB_TITLES[tab]} />
      <div className="design-page__card">
        <div className="design-page__content">
          <div
            className={`design-page__panel${tab !== 'colors' ? ' design-page__panel--hidden' : ''}`}
            aria-hidden={tab !== 'colors'}
          >
            <DesignColorsTab hasRestaurant={hasRestaurant} isActive={tab === 'colors'} />
          </div>
          <div
            className={`design-page__panel${tab !== 'fonts' ? ' design-page__panel--hidden' : ''}`}
            aria-hidden={tab !== 'fonts'}
          >
            <DesignFontsTab hasRestaurant={hasRestaurant} isActive={tab === 'fonts'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignPage;
